// @ts-nocheck

import { RouteMeta } from 'vue-router';
import {
  useAuthStore, useCompanyStore, useProjectStore,
} from '@/stores';
import { isExistOnQuery, preventPaddleRetainDuplication } from './retain-middleware';

export const LAST_REDIRECTED_ROUTE_KEY = 'router:lastRedirectedRoute';

export function navigationGuard(to: RouteMeta, from: RouteMeta, next: any) {
  const authStore = useAuthStore();
  const projectStore = useProjectStore();
  const companyStore = useCompanyStore();
  const isTargetPrelogin = (to.meta && to.meta.prelogin) || false;
  const isTargetLoading = to.name === 'Loading';
  const isTargetRedirect = to.name === 'Redirect';
  const isTargetAdminView = to.path.startsWith('/admin');
  const isPaddleRetainMode = isExistOnQuery('__pw_iic');

  if (window.Intercom && !to.path.includes('loading')) {
    window.Intercom('update', {
      referrer: to.path,
    });
  }

  // this will only work if url has __pw_iic query param
  // and referrer isn't login
  // and user is not in prelogin page
  if (isPaddleRetainMode && !isTargetPrelogin && (!to.query.referrer || to.query.referrer !== 'login')) {
    preventPaddleRetainDuplication();
  }

  if (isTargetAdminView) {
    if (authStore.isLoggedIn && authStore.loggedInUser && authStore.loggedInUser.isAdmin) {
      next();
    } else {
      next('/loading');
    }
    return;
  }

  if (isTargetLoading || isTargetRedirect) {
    next();
    return;
  }

  if (!isTargetPrelogin && !authStore.isLoggedIn) {
    localStorage.setItem(LAST_REDIRECTED_ROUTE_KEY, to.path);
  }

  if ((authStore.isLoggedIn && authStore.loggedInUser) || isTargetPrelogin || isTargetAdminView) {
    if (to.params.cid && to.params.pid) {
      projectStore.setSelectedProject(to.params.pid);
      companyStore.setSelectedCompany(to.params.cid);
    }

    next();
  } else {
    next('/loading');
  }
}
